export const moduleNamespace = 'appAmRisk';
export const routeNamespace = '/risk';
